import { css } from "@emotion/css";
import DotLayout from "components/dot-layout";
import moment from "moment";
import { converPlaceToText } from "utils/common";

interface Props {
	betData: any[];
	gameType: number;
}
function HistoryBetMobile(props: Props) {
	const { betData, gameType } = props;

	const mapPlaceBet = (betList: { place: number; stake: number }[]) => {
		let betObject: any = {};
		betList.forEach((item) => {
			if (betObject[item.place]) {
				betObject[item.place].stake += item.stake;
			} else {
				betObject = {
					...betObject,
					[item.place]: {
						stake: item.stake,
						place: item.place,
					},
				};
			}
		});
		const betListArr: { stake: number; place: number }[] = [];
		for (const key in betObject) {
			betListArr.push(betObject[key]);
		}

		return betListArr.map((item, index) => (
			<span key={index}>
				[{converPlaceToText(item.place, gameType)}]: {new Intl.NumberFormat().format(item.stake)}
			</span>
		));
	};
	return (
		<div className={styles.wrapHis}>
			{betData.map((item) => (
				<div className={styles.betRecord} key={item.id}>
					<div>
						<p className="label">Phiên:</p>
						<div className="labelVal">
							<p className="sessionID">{item.game.session_id}</p>
						</div>
					</div>
					<div>
						<p className="label">Đặt cược:</p>
						<div className="labelVal">
							<p>{new Intl.NumberFormat().format(item.stake)}</p>
						</div>
					</div>
					<div>
						<p className="label">Kết quả:</p>
						<div className="labelVal">
							{item.game.result ? (
								<DotLayout gameType={gameType} dotList={item.game.result} size={16} dotListAdjustment={item.adjustment} />
							) : item.game?.status?.id === 0 ? (
								<span>Chờ mở thưởng</span>
							) : (
								<span style={{ color: "#ff3838" }}>Phiên Huỷ</span>
							)}
						</div>
					</div>
					<div>
						<p className="label">Hoàn trả:</p>
						<div className="labelVal">
							{item.adjustment ? (
								<div className="wrapAdjustmentMoney">
									<div>
										<span className="moneyAdjustment">{new Intl.NumberFormat().format(item.refund)}</span>
									</div>
									<div>
										<span>{new Intl.NumberFormat().format(item.adjustment.refund)}</span>
									</div>
								</div>
							) : (
								<div>
									<span>{new Intl.NumberFormat().format(item.refund)}</span>
								</div>
							)}
						</div>
					</div>
					<div>
						<p className="label">Tiền thắng:</p>
						<div className="labelVal">
							{item.adjustment ? (
								<div className="wrapAdjustmentMoney">
									<div>
										<span className="moneyAdjustment">{new Intl.NumberFormat().format(item.win)}</span>
									</div>
									<div>
										<span style={{ color: item.adjustment.win > 0 ? "#00ff57" : "red" }}>{new Intl.NumberFormat().format(item.adjustment.win)}</span>
									</div>
								</div>
							) : (
								<span style={{ color: item.win > 0 ? "#00ff57" : "#fff" }}>{new Intl.NumberFormat().format(item.win)}</span>
							)}
						</div>
					</div>
					<div>
						<p className="label">Thời gian:</p>
						<div className="labelVal">
							<p>{moment(item.created_at).format("DD/MM/yyyy HH:mm:ss")}</p>
						</div>
					</div>
					<div>
						<p className="label">Cửa đặt:</p>
						<div className="labelVal valPlaced">{mapPlaceBet(item.bets)}</div>
					</div>
				</div>
			))}
		</div>
	);
}

const styles = {
	wrapHis: css`
		padding: 4px;
	`,
	betRecord: css`
		font-size: 0.85em;
		border-bottom: 1px solid #fbae3d;
		margin-bottom: 8px;
		padding-bottom: 8px;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		> div {
			width: 100%;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 4px;
			.label {
				font-weight: 600;
				color: #b3b3b3;
			}
			.labelVal {
				&.valPlaced {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					background: #333;
					padding: 0 4px 4px;
					border-radius: 5px;
					span {
						flex: 0 0 50%;
						padding-top: 4px;
					}
				}
				p {
					&.sessionID {
						color: #feaa31;
						font-weight: 600;
					}
				}
			}
			.wrapAdjustmentMoney {
				display: flex;
				gap: 8px;
				.moneyAdjustment {
					position: relative;
					&::before {
						content: "";
						position: absolute;
						top: 50%;
						left: 50%;
						width: 120%;
						height: 2px;
						background: #fff;
						margin-top: -1px;
						transform: translateX(-50%);
					}
				}
			}
		}
	`,
};

export default HistoryBetMobile;
